module.exports = __webpack_public_path__ + "img/PMountedArcher64_ua.02a69167.webp";